@if (useDefaultHeader) {
  <div id="dialog-header" class="wrapper">
    <div class="left">
      <h2>{{title}}</h2>
    </div>
    <div class="right">
      <button class="inherit-color-button" [mat-dialog-close]="false">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
}

@if (!useDefaultHeader) {
  <div id="dialog-custom-header">
    <ng-content select="[custom-header]"></ng-content>
  </div>
}

<div id="dialog-content" [ngClass]="useContentPadding ? 'default-content' : ''">
  <ng-content></ng-content>
</div>

@if (hasFootnote) {
  <div id="dialog-footnote">
    <mat-divider></mat-divider>
    <div class="footnote-padding">
      <ng-content select="[footnote]"></ng-content>
    </div>
  </div>
}